module.exports = __webpack_public_path__ + "static/media/copy-packet.6c56bfc8.svg";